const GreenBtn = ({text, onClick}) => {
    return (
        <button className="all-btn success-btn" type="button" onClick={onClick}>
            {text}
        </button>
    )
}

export default GreenBtn;